/**
 * @generated SignedSource<<6917c3be66e7162d982920cf5814cfe6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ApiSalesChannelInput = {
  currencyID?: string | null;
  id?: string | null;
  productApiUrl?: string | null;
  storeUrl?: string | null;
};
export type blankApiIntegrationSalesChannelDialogInsertMutation$variables = {
  input: ApiSalesChannelInput;
};
export type blankApiIntegrationSalesChannelDialogInsertMutation$data = {
  readonly upsertApiSalesChannel: {
    readonly clientID: number;
    readonly id: string;
    readonly salesChannelID: number;
    readonly secretKey: string | null;
  };
};
export type blankApiIntegrationSalesChannelDialogInsertMutation = {
  response: blankApiIntegrationSalesChannelDialogInsertMutation$data;
  variables: blankApiIntegrationSalesChannelDialogInsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ApiKey",
    "kind": "LinkedField",
    "name": "upsertApiSalesChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secretKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesChannelID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "blankApiIntegrationSalesChannelDialogInsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "blankApiIntegrationSalesChannelDialogInsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2121ea34fe827f73af3724b0ec6f55ae",
    "id": null,
    "metadata": {},
    "name": "blankApiIntegrationSalesChannelDialogInsertMutation",
    "operationKind": "mutation",
    "text": "mutation blankApiIntegrationSalesChannelDialogInsertMutation(\n  $input: ApiSalesChannelInput!\n) {\n  upsertApiSalesChannel(input: $input) {\n    id\n    clientID\n    secretKey\n    salesChannelID\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b991a1857455d9e7deeb7742183ec45";

export default node;
